import { animate, AnimationMetadata, state, style, transition, trigger } from '@angular/animations';

export const offcanvasAnimations: AnimationMetadata[] = [
	trigger('slideInOut', [
		state(
			'closed',
			style({
				transform: 'translateX(100%)',
				display: 'none',
			})
		),
		state(
			'open',
			style({
				transform: 'translateX(0)',
				display: 'flex',
			})
		),
		transition('closed => open', [
			style({ display: 'flex', transform: 'translateX(100%)' }),
			animate('200ms ease-out', style({ transform: 'translateX(0)' })),
		]),
		transition('open => closed', [
			animate('200ms ease-out', style({ transform: 'translateX(100%)' })),
		]),
	]),
];
